import { AlertCircle } from 'lucide-react'

import styles from './PermissionBanner.module.css'

/**
 * PermissionBanner — shown under the SearchBar when geolocation is denied.
 *
 * UI-SPEC §Components 6 (lines 317-331) + §Copywriting line 184.
 *   - `role="status"` (non-intrusive announcement, NOT `alert`).
 *   - 16px AlertCircle icon, body text "Location access denied.",
 *     trailing "How to enable" link to `/help/location` (stub target —
 *     real help page deferred per UI-SPEC line 185).
 *   - Mount fade: 150ms opacity via .visible class.
 */
export interface PermissionBannerProps {
  visible: boolean
  helpHref?: string
}

export function PermissionBanner({
  visible,
  helpHref = '/help/location',
}: PermissionBannerProps) {
  const classes = [styles.banner, visible ? styles.visible : '']
    .filter(Boolean)
    .join(' ')
  return (
    <div role="status" className={classes}>
      <AlertCircle size={16} className={styles.icon} aria-hidden="true" />
      <span className={styles.body}>Location access denied.</span>
      <a className={styles.link} href={helpHref}>
        How to enable
      </a>
    </div>
  )
}
